<template>
  <public-layout class="page-private-course">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <Loader v-if="!course"></Loader>
          <div class="columns is-vcentered" v-else>
            <div class="column is-7">
              <div class="languageButtons">
                <Button
                  :onClick="() => this.loadLanguage(1)"
                  :type="$route.params.langId == 1 ? 'primary':'secondary'"
                  size="small">English</Button>
                <!-- <Button v-if="course.id == 1" size="small"
                  :onClick="() => this.loadLanguage(2)"
                  :type="$route.params.langId == 2 ? 'primary':'secondary'">Suomi</Button>
                <Button v-if="course.id == 2" size="small"
                  :onClick="() => this.loadLanguage(4)"
                  :type="$route.params.langId == 4 ? 'primary':'secondary'">Français</Button>
                <Button v-if="course.id == 2" size="small"
                  :onClick="() => this.loadLanguage(7)"
                  :type="$route.params.langId == 7 ? 'primary':'secondary'">العربية</Button> -->
              </div>
              <h1 class="claim">{{ course.name }}</h1>
              <h2 class="subclaim">{{ course.subtitle }}</h2>
              <p class="description">{{ course.description }}</p>
              <template v-if="isEnrolled && courseProgress">
                <progress-bar class="course-progress" :max="courseProgress.modules.length" :progress="courseProgressBarProgress"></progress-bar>
                <div class="next-up">
                  <div>
                    <p class="next-up-label">Next up:</p>
                    <p>{{ nextLesson.module.name }} · {{ `${nextLesson.lesson.order + 1}. ${nextLesson.lesson.title}` }}</p>
                  </div>
                  <Button size="medium" :to="{
                    name: 'lesson',
                    params: { courseId: $route.params.courseId, langId: $route.params.langId, moduleId: nextLesson.module.id, lessonId: nextLesson.lesson.id }
                  }">{{ courseIsStarted ? 'Continue' : 'Start' }}</Button>
                </div>
                <!-- <Button size="medium" :onClick="unroll">Unroll</Button> -->
              </template>
              <template v-else>
                <Button size="medium" :loading="isEnrolling" :onClick="enroll">Enroll now</Button>
              </template>
            </div>

            <div class="column is-3 is-offset-1 is-hidden-mobile">
              <img :src="course.img" :alt="course.name + ' icon'">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <Loader v-if="!course || !course.modules.length"></Loader>
        <div class="timeline theme-checks" v-else>
          <div class="timeline-item" :class="getModuleState(module)" v-for="(module) in course.modules" :key="module.id" v-if="module.lessons.length">
            <course-module-card
              :id="module.id"
              :order="module.order"
              :name="module.name"
              :description="module.description"
              :userIsEnrolled="isEnrolled"
            ></course-module-card>
          </div>
        </div>
        <!-- <div>
          <div v-for="(module, index) in course.modules" :key="index">
            <router-link :to="{ name: 'lesson', params: { courseId: $route.params.courseId, moduleId: 1, lessonId: 1 }}">Module {{ module.id }}: {{ module.name }}</router-link>
          </div>
        </div> -->
        <router-view></router-view>
        <p class="download-subtitle">Download all 12 weeks of the Future Astronaut program as pdf in</p>
        <a v-if="$route.params.courseId == 1" class="button button-primary button-large" href="/static/Fun Academy - Future Astronaut Program - English.pdf" target="_blank">English</a>
        <a v-if="$route.params.courseId == 1" class="button button-primary button-large" href="/static/Fun Academy - Future Astronaut Program - Suomi.pdf" target="_blank">Suomi</a>
      </div>
    </section>
  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'

import ProgressBar from '@/components/ProgressBar'
import Button from '@/components/Button'
import Loader from '@/components/Loader'
import CourseModuleCard from '@/components/CourseModuleCard'

import { defaultCourseProgress } from '@/store/data/defaultCourseProgress'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    PublicLayout,
    ProgressBar,
    Button,
    Loader,
    CourseModuleCard
  },

  computed: {
    ...mapState('course', {
      course: state => state.course,
      courseProgress: state => state.progress
    }),

    ...mapState({
      userId: state => state.user.id
    }),

    nextLesson () {
      return {
        courseId: this.$route.params.courseId,
        module: this.course.modules[this.courseProgress.currentModule],
        lesson: this.course.modules[this.courseProgress.currentModule].lessons[this.courseProgress.currentLesson]
      }
    },

    courseIsStarted () {
      return this.courseProgress.currentModule > 0 || this.courseProgress.currentLesson > 0
    },

    courseIsCompleted () {
      return this.courseProgress.currentModule === this.courseProgress.modules.length - 1
    },

    courseProgressBarProgress () {
      return this.courseIsCompleted ? this.courseProgress.modules.length : this.courseProgress.currentModule
    }
  },

  methods: {
    ...mapActions('course', {
      getCourse: 'get',
      getCourseProgress: 'getProgress',
      setCourseProgress: 'setProgress',
      deleteCourseProgress: 'deleteProgress',
      setCourseId: 'setCourseId',
      setUserId: 'setUserId'
    }),

    ...mapActions({
      getUserCourses: 'getUserCourses'
    }),
    getCourseInfo () {
      this.setCourseId(this.$route.params.courseId)
      this.setUserId(this.userId)
      Promise.all([
        this.getCourse({courseId: this.$route.params.courseId, langId: this.$route.params.langId}),
        this.getUserCourses()
      ]).then(([course, userCourses]) => {
        if (userCourses.map(course => course.id).includes(course.id)) {
          this.isEnrolled = true
          this.getCourseProgress()
        }
      })

      // this.getCourse(this.$route.params.courseId).then(course => {
      //   this.setCourseId(this.$route.params.courseId)
      //   this.setUserId(this.userId)
      //   this.getUserCourses().then(userCourses => {
      //     if (userCourses.map(course => course.id).includes(this.$route.params.courseId)) {
      //       this.isEnrolled = true
      //       this.getCourseProgress()
      //     }
      //   })
      // })
    },

    loadLanguage (langId) {
      this.$router.push({name: 'course', params: {courseId: this.$route.params.courseId, langId: langId}}, this.getCourseInfo)
    },
    enroll () {
      this.isEnrolling = true
      let progressData = defaultCourseProgress
      for (var module of this.course.modules) {
        const lessonsTotal = module.lessons.length
        const nextLesson = module.lessons.find(lesson => lesson.order === 0)
        const status = module.order === 0 ? 'unlocked' : 'locked'
        let obj = Object.assign({}, module, { lessonsTotal, nextLesson, status })
        delete obj.name
        delete obj.subtitle
        delete obj.description
        progressData.modules.push(obj)
      }
      this.setCourseProgress(progressData)
        .then(() => {
          this.isEnrolled = true
        })
        .finally(() => {
          this.isEnrolling = false
        })
    },

    unroll () {
      this.deleteCourseProgress()
        .then(res => {
          this.isEnrolled = false
        })
    },

    getModuleState (module) {
      if (!this.courseProgress) {
        return 'unstarted'
      }

      if (this.courseProgress.currentModule === module.order) {
        return 'started'
      }
      if (this.courseProgress.currentModule > module.order) {
        return 'completed'
      }
      return 'unstarted'
    }
  },

  created () {
    this.getCourseInfo()
  },

  data () {
    return {
      isEnrolling: false,
      isEnrolled: false
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.page-private-course {
  .languageButtons {
    margin-bottom: 15px;
    button.button {
      margin-right: 5px;
    }
  }

  .main {

    h1, h2 {
      color: white;
    }
  }
  .hero {
    color: white;
    background-image: linear-gradient(-135deg, #0D1756 0%, #17143B 100%);
  }
  .claim {
    margin-bottom: 1rem;
    @include text-size-xxxl();
    font-weight: $font-weight-bold;
  }

  .subclaim {
    margin-bottom: 2.5rem;
    @include text-size-l();
  }

  .description {
    margin-bottom: 2rem;
  }

  .course-progress {
    margin-bottom: 2rem;
  }

  .next-up {
    display: flex;
    padding: .75rem 1.5rem;
    border: 1px solid rgba(255,255,255,.37);
    font-weight: $font-weight-semibold;

    .next-up-label {
      @include text-size-s();
    }

    .button {
      margin-left: auto;
    }
  }

  .hero-actions {
    margin-top: 2.5rem;

    > :not(:first-child) {
      margin-left: 1.5rem;
    }
  }
}

.download-subtitle{
  margin-bottom: 1.5rem;
}

.timeline {

  .timeline-item {
    padding-left: 3rem;
    padding-bottom: 3rem;
    @include text-size-s();
    position: relative;

    &:not(:last-child)::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      border-right: 1px solid $color-gray-light;
      transform: translate(6px, calc(3.2rem + 6px));
    }

    &::after {
      content: '';
      position: absolute;
      top: 3.2rem;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: $color-brand-main;
    }
  }

  &.theme-checks {

    .timeline-item {

      &:not(:last-child)::before {
        transform: translate(12px, calc(50% - 3rem + 12px))
      }

      &::after {
        width: 24px;
        height: 24px;
        top: calc(50% - 3rem);
        line-height: 24px;
      }

      &.completed::after {
        content: '✔';
        color: white;
        font-family: Helvetica, Arial, sans-serif;
      }

      &.started::after {
        border: 2px solid $color-brand-main;
        background-color: white;
      }

      &.unstarted::after {
        background-color: $color-gray-light;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/CoursePage.vue